<template>
    <div class="quotations-filters">
        <b-card>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            label="Código"
                            placeholder="Buscar por código"
                            v-model="filters.code"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            label="Título"
                            placeholder="Buscar por título"
                            v-model="filters.title"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select2-input
                            label="Estado"
                            placeholder="Seleccionar estado"
                            :options="statusOptions"
                            v-model="filters.status"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select2-input
                            label="Cliente"
                            placeholder="Seleccionar cliente"
                            :options="clientOptions"
                            v-model="filters.client_id"
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            label="Usuario"
                            placeholder="Buscar por usuario"
                            v-model="filters.user_id"
                        />
                    </b-col>
                    <b-col cols="12" md="3" class="d-flex align-items-center">
                        <b-form-checkbox
                            v-model="filters.show_disabled"
                            value="1"
                            unchecked-value="0"
                        >
                            Mostrar deshabilitadas
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="12" md="6" class="d-flex align-items-end">
                        <b-button variant="primary" @click="applyFilters" class="mr-2">
                            <i class="fa fa-filter"></i> Filtrar
                        </b-button>
                        <b-button variant="secondary" @click="clearFilters">
                            <i class="fa fa-times-circle"></i> Limpiar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormSelect2Input from '../../../UI/Controls/Forms/FormSelect2Input.vue';
import quotationsRepository from '../../../../repositories/quotations.repository';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelect2Input: FormSelect2Input
    },
    data() {
        return {
            filters: {
                code: '',
                title: '',
                status: null,
                client_id: null,
                user_id: null,
                show_disabled: '0'
            },
            statusOptions: [
                { id: 'draft', name: 'Borrador' },
                { id: 'sent', name: 'Enviada' },
                { id: 'approved', name: 'Aprobada' },
                { id: 'rejected', name: 'Rechazada' },
                { id: 'canceled', name: 'Cancelada' }
            ],
            clientOptions: []
        };
    },
    created() {
        this.loadClients();
    },
    methods: {
        applyFilters() {
            const activeFilters = {};
            
            Object.keys(this.filters).forEach(key => {
                const value = this.filters[key];
                if (value !== null && value !== undefined && value !== '') {
                    // Convertir show_disabled a with_trashed para el backend
                    if (key === 'show_disabled') {
                        activeFilters['with_trashed'] = value === '1' || value === true || value === 1;
                    } else {
                        activeFilters[key] = value;
                    }
                }
            });
            
            this.$emit('filter', activeFilters);
        },
        clearFilters() {
            this.filters = {
                code: '',
                title: '',
                status: null,
                client_id: null,
                user_id: null,
                show_disabled: '0'
            };
            this.$emit('filter', null);
        },
        loadClients() {
            const pr = { ...quotationsRepository };
            pr.getClients()
                .then(response => {
                    if (response && Array.isArray(response)) {
                        this.clientOptions = response.map(client => ({
                            id: client.id,
                            name: client.name
                        }));
                    }
                })
                .catch(error => {
                    console.error('Error al cargar clientes:', error);
                });
        }
    }
};
</script>

<style scoped>
.quotations-filters {
    margin-bottom: 20px;
}
</style>

